module.exports = __webpack_public_path__ + "static/slide-dog-3-f0af0b35ecd47bb82ad5679064ba3b5e.png";